import React, { useEffect, useState } from 'react';
import {
	Typography,
	Card,
	CardMedia,
	Stack,
	Link,
	Container,
	Grid,
	Box,
	Chip,
	useTheme,
} from '@mui/material';
import ConstructionIcon from '@mui/icons-material/Construction';
import { minimalLabelTheme } from '@/app/theme';
import UnderMaintenance from '@/assets/images/under-maintenance.png';
import crmLogo from '@/assets/images/folioCRM.png';
import darkCrmLogo from '@/assets/images/folioCRM_dark_matched.png';
import { useFeatureFlagContext } from '@/context/featureFlagContext';
import { SignInButton } from '@/components/buttons/SignInButton';
import { useSelector } from 'react-redux';
import { IS_DEV, IS_PRE } from '@/utils/environment';

const UnderMaintenancePage = () => {
	const theme = useTheme();
	const logo = theme.palette.mode === 'dark' ? crmLogo : darkCrmLogo;
	const { account } = useSelector((state) => state.msalAccount);
	const email = account?.username;

	const { getFeatureFlags } = useFeatureFlagContext();

	const featureFlag = getFeatureFlags('siteActive');
	const someActive =
		(featureFlag?.userIds ?? []).length > 0 || (featureFlag?.brokerGroupIds ?? []).length > 0;

	const [active, setActive] = useState(false);

	useEffect(() => {
		let intervalId;

		const checkRunStatus = async () => {
			setActive(getFeatureFlags('siteActive')?.active);
		};

		if (!active) {
			intervalId = setInterval(checkRunStatus, 10000); // Check every 10 seconds
		}

		return () => clearInterval(intervalId);
	}, [active]);

	return (
		<Container>
			<Grid
				container
				spacing={2}
				style={{ height: '100vh', overflow: 'hidden', display: 'flex' }}
			>
				<Grid size={6} style={{ height: '100%' }}>
					<Card sx={{ width: '100%', height: '100%', borderRadius: 0 }}>
						<CardMedia
							component='img'
							height='100%'
							width='100%'
							src={UnderMaintenance}
							alt='Under maintenance'
							sx={{ objectFit: 'cover' }}
						/>
					</Card>
				</Grid>
				<Grid size={6} container justifyContent='center' alignItems='center'>
					<Stack direction='column'>
						<Card sx={{ padding: 8 }}>
							<Stack
								direction='column'
								justifyItems={'space-between'}
								alignContent={'flex-start'}
								spacing={3}
							>
								<Stack>
									<Stack direction='row' alignItems='center' spacing={1}>
										<Box
											component='img'
											src={logo}
											alt='Folio CRM'
											sx={{ height: 30, width: 'auto' }}
										/>
										{IS_DEV && (
											<Chip label='DEV' color='primary' size='small' />
										)}
										{IS_PRE && (
											<Chip label='PRE' color='secondary' size='small' />
										)}
									</Stack>

									<Stack
										direction='row'
										alignContent={'center'}
										pb={2}
										pt={1}
										spacing={1}
									>
										<ConstructionIcon />
										<Typography variant='subtitle1'>
											Under Maintenance
										</Typography>
									</Stack>
									<Typography sx={{ marginBottom: 4 }}>
										The Folio Broker Portal is currently undergoing maintenance.
										Please check back soon.
									</Typography>
								</Stack>
								{!email && someActive && (
									<Box>
										<SignInButton
											variant='text'
											sx={{
												backgroundColor: 'transparent',
												'&:hover': {
													backgroundColor: theme.palette.action.hover,
												},
												padding: '4px 6px',
												border: 'none',
												'& img': {
													height: '20px !important',
													width: '20px !important',
												},
												'& .MuiTypography-root': {
													fontSize: '12px',
												},
											}}
										/>
									</Box>
								)}
							</Stack>
						</Card>
						<Typography sx={{ ...minimalLabelTheme, marginTop: 1 }}>
							Need help? Email{' '}
							<span>
								<Link
									href={'mailto:support@folio.insure'}
									target='_blank'
									rel='noopener noreferrer'
								>
									support@folio.insure
								</Link>
							</span>{' '}
							for assistance.
						</Typography>
					</Stack>
				</Grid>
			</Grid>
		</Container>
	);
};

export default UnderMaintenancePage;
